import BillingCounterService from '@/services/billing_counter';

export default {
	namespaced: true,
	state: {},

	getters: {},

	actions: {
		async getBillingCounterByCompany({ commit, state, getters, dispatch }, payload) {
			try {
				let response = await BillingCounterService.getBillingCounterByCompany(payload.company_id);

				return response.data.attributes;
			} catch (e) {
				console.log(e);
			}
		}
	},

	mutations: {}
};
